import map from 'lodash/map';
import get from 'lodash/get';
import each from 'lodash/each';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import times from 'lodash/times';
import flow from 'lodash/flow';
import zip from 'lodash/zip';
import first from 'lodash/first';
import every from 'lodash/every';
import mapValues from 'lodash/mapValues';
import defer from 'lodash/defer';
import includes from 'lodash/includes';
import filter from 'lodash/filter';
import difference from 'lodash/difference';
import forEach from 'lodash/forEach';

import {
  LINK_TYPE_INTERNAL,
  LINK_TYPE_EXTERNAL
} from 'zoomforth_codesbane_viewer/const/link_types.js';

import loglevel from 'loglevel';

import {
  generateNewSectionData
} from 'zoomforth_codesbane_editor/lib/sections.js';

import {
  generateEid,
  generateGridTaxonomyCategoryId,
  generateGridTaxonomyTagId
} from 'zoomforth_codesbane_editor/lib/id_generators.js';

import { getUuidFrom, getIdFrom } from 'zoomforth_codesbane_viewer/lib/id_utils.js';

import { get as getPageHistoryTracker } from 'zoomforth_zf/appglobals/page-history-tracker.js';

import { 
  CONTENT_TYPE_ASSET
} from 'zoomforth_codesbane_viewer/const/content_types.js';

import {
  TILE_EDITOR_TAB_STYLING,
  VALID_TILE_EDITOR_TABS
} from 'zoomforth_codesbane_editor/const/const.js';

import {
  showErrorNotification
} from './misc.js';

import {
  prependSchemeIfMissing
} from 'zoomforth_zfutils/url_validators.js';

import {
  setClipboardData,
  fetchClipboardDataForType
} from './user_clipboard.js';

import {
  showModal
} from './editor_modals.js';

import {
  updateAssetData,
  setAndUpdateAssetData
} from './asset.js';

import {
  ensureThrottledPageConfigSaving
} from './config.js';

import {
  getEditorTileEidByContentUuid,
  getEditorTileGridPositionByEid,
  createEditorTileAtPosition,
  createEditorTileAtEnd,
  setEditorTileData,
  setEditorTileContent,
  removeEditorTiles,
  removeEditorTileData,
  getTileCreatorEid,
  isTileCreatorTile,
  hasAnyTileCreator
} from 'zoomforth_codesbane_editor/lib/section_overrides/grid_section_overrides.js';

import {
  generateInitialSectionOverridesForSection
} from 'zoomforth_codesbane_editor/lib/section_overrides/index.js';

import {
  getNextAvailablePositionForTile
} from 'zoomforth_codesbane_editor/lib/grid_positions.js';

import {
  getContentPayloadForReplace,
  getContentItemType,
  getSerializableContentDataForCopy,
  hasCroppableAssetDisplayImage
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

import {
  getZfImageForImageSrc,
  getZfImageForAsset
} from 'zoomforth_media_library/lib/assets.js';

import {
  getAssetForContent,
  getContentItemByUuid,
  getSectionById,
  getCurrentSubpage,
  getSectionForContent,
  getSubpageForSection,
  getOrderedContentUuidsForSection,
  getPrimaryMenuItemForSubpage,
  getSerializableTileData,
  getSectionGridTaxonomyCategory,
  getSubpageDisplayName
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  getDisplayName
} from 'zoomforth_codesbane_viewer/lib/sections.js';

import {
  goToContent,
  scrollToSection
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

import {
  getEditorOnlySectionOverrides,
  getCurrentlyEditingContentItems,
  getTemporaryTileActionData,
  getIsChoosingTarget,
  getGridSectionSingleTileEditorCurrentTab
} from 'zoomforth_codesbane_editor/reducers/index.js';

import {
  getCachedCroppedZfImageFromAsset,
  uploadFileAndFetchAsset
} from 'zoomforth_codesbane_editor/lib/assets.js';

import {
  setContentItemAsset,
  deleteContentItems,
  createContentItemFromAsset,
  createTextContentItem,
  createIframeEmbedContentItem,
  createContentItem,
  setContentItemSimpleData,
  createSectionlessContentItem
} from './content.js';

import {
  setSectionAndOverrides,
  removeSection
} from './sections.js';

import {
  beginEditingContent,
  endEditingContent,
  setEditingContent
} from './misc.js';

import {
  showCropperForTile,
  cropTileFromContentItemIfNeeded
} from './cropper.js';

import {
  fetchAndUpdateAssetData
} from './asset.js';

import {
  editTargetForInternalLink
} from './internal_link_target.js';

import ConfirmDeleteTileModal
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/confirm_delete_tile_container.jsx';

import ConfirmCreatePresentationForTileModal
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/confirm_create_presentation_for_tile_container.jsx';

import ConfirmCreateHtmlPackageForTileModal
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/confirm_create_html_package_for_tile_container.jsx';

import {
  ADD_SECTION,
  SET_SHOULD_SHOW_GRID_LINES,
  SET_IS_GRID_TAXONOMY_ENABLED,
  ADD_GRID_TAXONOMY_CATEGORY,
  REMOVE_GRID_TAXONOMY_CATEGORY,
  SET_GRID_TAXONOMY_CATEGORY_DATA,
  SET_GRID_TAXONOMY_CATEGORIES_ORDER,
  SET_GRID_TAXONOMY_FILTER_TYPE,
  SET_GRID_TAXONOMY_FILTER_LOGICAL_OPERATOR,
  SET_GRID_TAXONOMY_FILTER_TOGGLE_TEXT,
  SET_EDITING_TILE_CAPTION
} from 'zoomforth_codesbane_editor/action_types.js';

import {
  CLIPBOARD_ITEM_TYPE_TILE
} from 'zoomforth_codesbane_editor/lib/user_clipboard/const.js';

const getSectionAndOverrides = (state, sectionOrId)=> {
  const sectionId = getIdFrom(sectionOrId);
  const section = getSectionById(state, sectionId);
  const sectionOverrides = getEditorOnlySectionOverrides(state, sectionId);
  return {
    section,
    sectionOverrides
  };
};


export const setEditingTileCaption = (contentItem)=>
  (dispatch, getState)=> {
    const contentUuid = contentItem ? getUuidFrom(contentItem) : null;
    dispatch({ type: SET_EDITING_TILE_CAPTION, contentUuid });
  };


export const addTileCreatorTileAtEnd = (sectionOrId)=>
  (dispatch, getState)=> {
    const sectionId = getIdFrom(sectionOrId);

    const section = getSectionById(getState(), sectionId);
    const sectionOverrides = getEditorOnlySectionOverrides(getState(), sectionId);

    const { editorOnlyTileDataByEid } = sectionOverrides;

    /**
     * This rule will always apply.
     * 
     * We always want at least 1 tile creator tile for
     * each grid section.
     * 
     * We only want as many tile creator tiles as we
     * specify for that section.
     **/
    if (!hasAnyTileCreator(editorOnlyTileDataByEid)) {
      const newEid = generateEid();
      const [newSection, newSectionOverrides] = flow(

        ([section, sectionOverrides])=>
          createEditorTileAtEnd(section, sectionOverrides, newEid)
        ,
        ([section, sectionOverrides])=>
          setEditorTileData(section, sectionOverrides, newEid, { isTileCreator: true })
      
      )([section, sectionOverrides]);

      dispatch(setSectionAndOverrides(sectionId, newSection, newSectionOverrides));
    }
  };


export const beginEditingTiles = (contentItemsOrUuids, tab=TILE_EDITOR_TAB_STYLING)=>
  (dispatch, getState)=> { 
    const currentTab = getGridSectionSingleTileEditorCurrentTab(getState());
    dispatch(setSingleTileEditorCurrentTab(currentTab || tab));
    dispatch(beginEditingContent(contentItemsOrUuids));
  };


export const editTemporaryTileActionDataTargetForInternalLink = (sectionOrId)=>
  (dispatch, getState)=> {
    const temporaryTileActionData = getTemporaryTileActionData(getState());
    dispatch(editTargetForInternalLink(
      sectionOrId,
      temporaryTileActionData.sectionId,
      temporaryTileActionData.contentUuid
    ));
  };
  

export const endEditingTiles = (contentItemsOrUuids, tab=TILE_EDITOR_TAB_STYLING)=>
  (dispatch, getState)=> {
    const currentTab = getGridSectionSingleTileEditorCurrentTab(getState());
    dispatch(setSingleTileEditorCurrentTab(currentTab || tab));
    dispatch(endEditingContent(contentItemsOrUuids));
  };

export const setEditingTiles = (contentItemsOrUuids, tab=TILE_EDITOR_TAB_STYLING)=>
  (dispatch, getState)=> {
    const currentTab = getGridSectionSingleTileEditorCurrentTab(getState());
    dispatch(setSingleTileEditorCurrentTab(currentTab || tab));
    dispatch(setEditingContent(contentItemsOrUuids));
  };


export const interactOutsideEditingTile = ()=>
  (dispatch, getState)=> {
    if (!getIsChoosingTarget(getState())) {
      // If we are choosing a target then we dont want to un-select our currently editing content
      dispatch(setEditingTiles([]));
      dispatch(setEditingTileCaption(null));
    } 
  };


const prepNewTilesForContent = (
  dispatch,
  getState,
  sectionOrId,
  eid,
  tileCount,
  { shouldCreateEditorTileAtEnd=true }={}
)=> {
  const sectionId = getIdFrom(sectionOrId);

  // in a 1:1 replacement we want to copy the current content item data into
  // the new content item to be created. in this way we maintain the attributes
  // which have been previously set.
  //
  // we also rely on eid and tileCount instead of a flag because they are the
  // baseline criteria. we need content that exists at the eid (not a tile
  // creator tile) and only in the case where the 1:1 exchange happens do we
  // want to go through with things.

  const {
    section: preSection, // remapping these since we want to declare them below after everything is properly prepped
    sectionOverrides: preSectionOverrides
  } = getSectionAndOverrides(getState(), sectionId);

  const isTileCreator = isTileCreatorTile(preSection, preSectionOverrides, eid);

  var shouldCopyContentDataForNewContent = !isTileCreator && tileCount === 1;

  if (!eid) {
    let { section, sectionOverrides } = getSectionAndOverrides(getState(), sectionId);
    // When a eid of a tile to replace isn't specified we replace the tile creator
    eid = getTileCreatorEid(section, sectionOverrides);
  }

  dispatch(prepTileForReplace(sectionOrId, eid, { addTileAtEnd: shouldCreateEditorTileAtEnd }));

  let { section, sectionOverrides } = getSectionAndOverrides(getState(), sectionId);

  const { editorOnlyTileDataByEid } = sectionOverrides;
  const newEids = times(tileCount - 1, generateEid);
  const eids = [eid, ...newEids];

  // @TODO: We should do this elsewhere
  const makeFuncCreateEditorTile = (eid)=>
    ([section, sectionOverrides])=> (
      shouldCreateEditorTileAtEnd || !hasAnyTileCreator(editorOnlyTileDataByEid) ?
        createEditorTileAtEnd(section, sectionOverrides, eid)
      : {}
    );

  const makeFuncSetIsPreparing = (eid)=>
    ([section, sectionOverrides])=>
      setEditorTileData(section, sectionOverrides, eid, { isPreparing: true });

  [section, sectionOverrides] = flow([
    ...map(newEids, makeFuncCreateEditorTile),
    ...map(eids, makeFuncSetIsPreparing)

  ])([section, sectionOverrides]);

  dispatch(setSectionAndOverrides(sectionId, section, sectionOverrides));

  var payloadForReplace = undefined;

  if (shouldCopyContentDataForNewContent) {
    const { uuid } = getEditorTileGridPositionByEid(section, sectionOverrides, eid);
    const contentItem = getContentItemByUuid(getState(), uuid);

    payloadForReplace = getContentPayloadForReplace(contentItem);
  }

  each(eids, eid => {
    dispatch(deleteTileContentIfPresentForEid(sectionOrId, eid));
  });

  return {
    eids,
    section,
    sectionOverrides,
    payloadForReplace
  };
};

export const addMediaLibraryAssetToImageTileInSubpage = (
  sectionOrId,
  asset,
  { eid },
  imageData={}
) =>
  (dispatch, getState) => {
    const subpage = getCurrentSubpage(getState());
    const menuItemForSubpage = getPrimaryMenuItemForSubpage(getState(), subpage);

    const {
      section,
      sectionOverrides,
      payloadForReplace
    } = prepNewTilesForContent(
        dispatch,
        getState,
        sectionOrId,
        eid,
        1,
        { shouldCreateEditorTileAtEnd: true }
      );

    dispatch(updateAssetData(asset));

    const onReceiveContentItem = (contentItem) => {
      const contentType = getContentItemType(contentItem);
      const asset = getAssetForContent(getState(), contentItem);
      const isEncoding = get(asset, 'isEncoding');

      const { uuid } = contentItem;
      const { sizex, sizey } =
        getEditorTileGridPositionByEid(section, sectionOverrides, eid);

      dispatch(setContentItemAsset(contentItem, asset));

      getPageHistoryTracker()
        .trackReplaceTileAsset(contentType, uuid);

      dispatch(setTileContentItem(
        section,
        eid,
        uuid,
        { canShowUserCropModal: false }
      ));

      getPageHistoryTracker()
        .trackAddContent(uuid, contentType, menuItemForSubpage.title);

      if (!isEncoding) {
        dispatch(beginEditingContent([contentItem]));
      }

      dispatch(goToContent(contentItem));

      dispatch(ensureThrottledPageConfigSaving());

      defer(() => {
        dispatch(cropTileFromContentItemIfNeeded({ contentItem, sizex, sizey }));
      });
    };

    dispatch(createSectionlessContentItem(
      {
        ...payloadForReplace,
        ...imageData,
        tile_action_data: { type: 'none' },
        isTileCreator: false,
        content_type: CONTENT_TYPE_ASSET,
        asset_type: asset.assetType,
        asset_id: asset.assetId
      },
      onReceiveContentItem
    ));

    getPageHistoryTracker()
      .trackAddMediaLibraryAssetToGridInSubpage(menuItemForSubpage.title);
  };

export const addMediaLibraryAssetsToGridInSubpage = (sectionOrId, assets, { eid })=>
  (dispatch, getState)=> {

    const subpage = getCurrentSubpage(getState());
    const menuItemForSubpage = getPrimaryMenuItemForSubpage(getState(), subpage);

    const {
      eids,
      section,
      payloadForReplace
    } = prepNewTilesForContent(dispatch, getState, sectionOrId, eid, assets.length);

    each(zip(eids, assets), ([eid, asset]) => {
      dispatch(createTileFromAsset(section, asset, { eid }, payloadForReplace, {canShowUserCropModal:assets.length === 1}));
    });

    getPageHistoryTracker()
      .trackAddMediaLibraryAssetToGridInSubpage(menuItemForSubpage.title);
  };


export const beginUploadToTiles = (sectionOrId, eid, files, forceAssetType = null)=>
  (dispatch, getState)=> {

    const {
      eids,
      payloadForReplace
    } = prepNewTilesForContent(dispatch, getState, sectionOrId, eid, files.length);

    each(zip(eids, files), ([eid, file])=> {

      const dispatchSetTileData = (data)=> {
        let { section, sectionOverrides } = getSectionAndOverrides(getState(), sectionOrId);
        [section, sectionOverrides] = setEditorTileData(section, sectionOverrides, eid, data);
        dispatch(setSectionAndOverrides(section.id, section, sectionOverrides));
      };

      uploadFileAndFetchAsset(file, {
        uploadContext: 'page',
        forceAssetType: forceAssetType,
        onProgressChange:({ isUploading, isProcessing, isFetching, percent })=> {
          dispatchSetTileData({ isUploading, isProcessing, isFetching, percent });
        }, 
        onAssetReceive:(asset)=> {
          const subpage = getCurrentSubpage(getState());
          const menuItemForSubpage = getPrimaryMenuItemForSubpage(getState(), subpage);

          getPageHistoryTracker()
            .trackAddMediaLibraryUploadToSubpage(menuItemForSubpage.title);

          dispatch(createTileFromAsset(sectionOrId, asset, { eid }, payloadForReplace, {canShowUserCropModal: files.length === 1}));
        },
        onError: (errorData={})=> {
          const errorMessage = errorData.error ? errorData.error : 
            'Something went wrong while uploading your file. Please try again later.';

          dispatch(showErrorNotification('Upload failed', errorMessage));

          dispatchSetTileData({ error:errorMessage });
          setTimeout(()=> {
            let { section, sectionOverrides } = getSectionAndOverrides(getState(), sectionOrId);
            [section, sectionOverrides] = removeEditorTiles(section, sectionOverrides, [eid]);
            dispatch(setSectionAndOverrides(section.id, section, sectionOverrides));
          }, 5000);
        } 
      });

    });

  };


export const createTextTile = (sectionOrId, eid, isForReplace=false)=>
  (dispatch, getState)=> {
    const { section, sectionOverrides } = getSectionAndOverrides(getState(), sectionOrId);

    dispatch(prepTileForReplace(sectionOrId, eid));

    var extraData = {};

    if (isForReplace) {
      const { uuid } = getEditorTileGridPositionByEid(section, sectionOverrides, eid);
      const contentItem = getContentItemByUuid(getState(), uuid);

      extraData = getContentPayloadForReplace(contentItem);
    }

    dispatch(createTextContentItem(section, { eid }, extraData));
  };

export const createWebPreviewTIle = (
  section,
  contentData,
  { eid },
  { isForReplace=false }={}
) =>
  (dispatch, getState) => {
    dispatch(prepTileForReplace(section, eid));
    dispatch(createContentItem(section, contentData, { eid }, { isForReplace }));
  };

export const createIframeEmbedTile = (sectionOrId, iframeEmbedUrl, eid)=>
  (dispatch, getState)=> {
    const { section } = getSectionAndOverrides(getState(), sectionOrId);
    dispatch(prepTileForReplace(sectionOrId, eid));
    dispatch(createIframeEmbedContentItem(section, iframeEmbedUrl, { eid }));
  };


export const createTileFromAsset = (
  sectionOrId,
  asset,
  { eid },
  extraData={},
  {
    isForReplace=false,
    shouldEditOnCreate,
    canShowUserCropModal,
    shouldScrollToOnCreate
  }={}
)=>
  (dispatch, getState)=> {

    const { section } = getSectionAndOverrides(getState(), sectionOrId);
    const sectionOverrides = getEditorOnlySectionOverrides(getState(), section.id);
    const { sizex, sizey } = getEditorTileGridPositionByEid(section, sectionOverrides, eid);

    const tileExtraData = {};

    var zfImage = getCachedCroppedZfImageFromAsset(asset, { sizex, sizey });
    if(zfImage){
      // A cropped image already exists for this tile size which means it should be displayed
      tileExtraData.tile_display_type = 'library';
    }else{
      zfImage = getZfImageForAsset(asset);
    }

    dispatch(prepTileForReplace(sectionOrId, eid, { addTileAtEnd: true }));

    if (asset.assetType === 'photo') {
      // We must specify a none action for photos because we interpret null type_action_data
      // as "overlay" types due to legacy compatibility reasons
      tileExtraData.tile_action_data = { type: 'none' }; 
    } else if (asset.assetType === 'html_package') {
      // these default to embedded so we need to explicitly set the none option here
      tileExtraData.tile_action_data = { type: 'none' }; 
    }

    if (isForReplace) {
      const { uuid } = getEditorTileGridPositionByEid(section, sectionOverrides, eid);
      const contentItem = getContentItemByUuid(getState(), uuid);

      extraData = { ...getContentPayloadForReplace(contentItem), ...extraData };
    }

    dispatch(createContentItemFromAsset(
      section,
      asset,
      { eid, sizex, sizey },
      {
        ...tileExtraData,
        ...extraData
      },
      { shouldEditOnCreate, canShowUserCropModal, shouldScrollToOnCreate }
    ));

  };


/*
  An eid may represent a tile without a content item (e.g., a tile creator tile).
*/
export const deleteTileContentIfPresentForEid = (sectionOrId, eid)=>
  (dispatch, getState)=> {
    const sectionId = getIdFrom(sectionOrId);
    const section = getSectionById(getState(), sectionId);
    const sectionOverrides = getEditorOnlySectionOverrides(getState(), sectionId);
    const { uuid } = getEditorTileGridPositionByEid(section, sectionOverrides, eid);
    if (uuid) {
      dispatch(deleteContentItems([uuid]));
    }
  };

export const setSingleTileEditorCurrentTab = (currentTab)=> {
  if (!includes(VALID_TILE_EDITOR_TABS, currentTab)) {
    throw new Error(`Not a valid tab ${currentTab}`);
  }
  return {
    type: 'SET_GRID_SECTION_SINGLE_TILE_EDITOR_CURRENT_TAB',
    currentTab
  };
};


export const deleteTiles = (contentItemsOrUuids)=>

  (dispatch, getState)=> {

    const contentUuids = map(contentItemsOrUuids, getUuidFrom);

    const section = getSectionForContent(getState(), first(contentUuids));

    if (!every(map(contentUuids, (uuid)=> getSectionForContent(getState(), uuid).id === section.id ))) {
      throw new Error('Cannot delete tiles from multiple sections at once');
    }

    const sectionOverrides = getEditorOnlySectionOverrides(getState(), section.id);

    const eidsToRemove = map(contentUuids, (contentUuid)=> 
      getEditorTileEidByContentUuid(section, sectionOverrides, contentUuid)
    );

    const [newSection, newSectionOverrides] = removeEditorTiles(section, sectionOverrides, eidsToRemove);

    dispatch(endEditingContent(contentItemsOrUuids));
    dispatch(setSectionAndOverrides(section.id, newSection, newSectionOverrides));

    each(contentUuids, (uuid)=> {
      const contentItem = getContentItemByUuid(getState(), uuid);
      const contentType = getContentItemType(contentItem);

      getPageHistoryTracker()
        .trackDeleteTile(contentType, contentItem.uuid);

      dispatch(deleteContentItems([uuid]));
    });
  };


export const deleteGridSection = (sectionOrId)=>
  (dispatch, getState)=> {

    const contentUuids = getOrderedContentUuidsForSection(getState(), sectionOrId);
    if (!isEmpty(contentUuids)) {
      // Delete tile currently queries section data from state so we must do it first
      // It may be possible to to just use `deleteContentItem` here and delete section first
      dispatch(deleteTiles(contentUuids));
    }
    dispatch(removeSection(sectionOrId));
  };

export const copyTile = (contentItemOrUuid)=>
  (dispatch, getState)=> {
    const contentUuid = getUuidFrom(contentItemOrUuid);
    const contentItem = getContentItemByUuid(getState(), contentUuid);
    dispatch(copyTiles([contentItem]));
  };

export const copyTiles = (contentItems)=>
  (dispatch, getState)=> {
    const serializableTileData = map(contentItems, (contentItem)=> {
      return getSerializableTileData(getState(), contentItem);
    });

    dispatch(setClipboardData(CLIPBOARD_ITEM_TYPE_TILE, serializableTileData));
  };

export const pasteCopiedTileDataIntoSection = (sectionOrId)=>
  (dispatch, getState)=> {
    dispatch(fetchClipboardDataForType(CLIPBOARD_ITEM_TYPE_TILE, (serializableTileData)=> {
      const { section } = getSectionAndOverrides(getState(), sectionOrId);

      if (!serializableTileData ) {
        loglevel.error('No tile data found to paste -- paste was enabled though');
        dispatch(showErrorNotification(
          'Clipboard Error',
          'Could not retrieve tile data from your clipboard.'
        ));
        return;
      }

      const postCreateData = {
        shouldCreateAtEnd: true,
        shouldCreateTileCreatorAtPosition: false,
        shouldEditOnCreate: true,
        shouldScrollToOnCreate: true,
        canShowUserCropModal: true
      };

      const { contentItemData, sizex, sizey } = serializableTileData;
      dispatch(createContentItemFromContentForGridSection(section, contentItemData, { sizex, sizey }, postCreateData));
    }));
  };

export const pasteMultipleCopiedTilesDataIntoSection = (sectionOrId, clipboardItems) =>
  (dispatch, getState) => {
    const { section } = getSectionAndOverrides(getState(), sectionOrId);

    if (!clipboardItems) {
      loglevel.error('No tile data found to paste -- paste was enabled though');
      dispatch(showErrorNotification(
        'Clipboard Error',
        'Could not retrieve tile data from your clipboard.'
      ));
      return;
    }

    const postCreateData = {
      shouldCreateAtEnd: true,
      shouldCreateTileCreatorAtPosition: false,
      shouldEditOnCreate: false,
      shouldScrollToOnCreate: true,
      canShowUserCropModal: false
    };

    each(clipboardItems, ({ data }) => {
      const { contentItemData, sizex, sizey } = data;
      dispatch(createContentItemFromContentForGridSection(section, contentItemData, { sizex, sizey }, postCreateData));
    });
  };

export const duplicateTile = (contentItemOrUuid, { shouldCreateAtEnd=true, shouldScrollToOnCreate=true, shouldEditOnCreate=true, canShowUserCropModal=true } = {})=>
  (dispatch, getState)=> {
    const section = getSectionForContent(getState(), contentItemOrUuid);
    const { contentItemData, sizex, sizey } = getSerializableTileData(getState(), contentItemOrUuid);

    const postCreateData = {
      shouldCreateAtEnd: shouldCreateAtEnd,
      shouldEditOnCreate: shouldEditOnCreate,
      shouldScrollToOnCreate: shouldScrollToOnCreate,
      canShowUserCropModal: canShowUserCropModal
    };

    dispatch(createContentItemFromContentForGridSection(section, contentItemData, { sizex, sizey }, postCreateData));

    dispatch(endEditingTiles([contentItemOrUuid]));
  };

export const duplicateTiles = (contentItems)=>
  (dispatch)=> {
    each(contentItems, (contentItem)=> {
      dispatch(duplicateTile(contentItem, { canShowUserCropModal: false }));
    });
  };

export const prepTileForReplace = (sectionOrId, eid, { addTileAtEnd }={ addTileAtEnd: true })=>
  (dispatch, getState)=> {
    const { section, sectionOverrides } = getSectionAndOverrides(getState(), sectionOrId);
    const isTileCreator = isTileCreatorTile(section, sectionOverrides, eid);
    dispatch(replaceTileWithPendingTile(section, eid));

    if (isTileCreator && addTileAtEnd) {
      dispatch(addTileCreatorTileAtEnd(sectionOrId));
    } 
  };


export const replaceTileWithPendingTile = (sectionOrId, eidToReplace)=>
  (dispatch, getState)=> {

    const { section, sectionOverrides } = getSectionAndOverrides(getState(), sectionOrId);

    const [newSection, newSectionOverrides] =
     setEditorTileData(section, sectionOverrides, eidToReplace, { isLoading:true });

    dispatch(
      setSectionAndOverrides(section.id, newSection, newSectionOverrides)
    );

  };


export const setColumnCount = (sectionOrId, columnCount)=>
  (dispatch, getState)=> {
    const sectionId = getIdFrom(sectionOrId);
    const section = getSectionById(getState(), sectionId);

    const newGridPositions = [];
    each(section.gridPositions, (oldPosition) =>{
      const newPosition = getNextAvailablePositionForTile(oldPosition, newGridPositions, columnCount);
      newGridPositions.push(newPosition);
    });
    
    const sectionOverrides = getEditorOnlySectionOverrides(getState(), sectionId);
    const newEditorPositions = [];
    const newEditorPositionsByEid = mapValues(sectionOverrides.editorOnlyGridPositionsByEid, (editorPosition)=> {
      const occupiedPositions = newEditorPositions.concat(newGridPositions);
      const newEditorPosition = getNextAvailablePositionForTile(editorPosition, occupiedPositions, columnCount);
      newEditorPositions.push(newEditorPosition);
      return newEditorPosition;
    });
    const newSectionOverrides = {
      ...sectionOverrides,
      editorOnlyGridPositionsByEid: newEditorPositionsByEid
    };
    
    dispatch({
      type: 'SET_COLUMN_COUNT',
      sectionId,
      columnCount
    });

    dispatch(setSectionAndOverrides(sectionId, { gridPositions: newGridPositions }, newSectionOverrides));
  };


export const setFormTileAsset = (contentItem, asset)=>
  (dispatch)=> {
    const contentType = getContentItemType(contentItem);

    dispatch(setContentItemAsset(contentItem, asset)); 

    getPageHistoryTracker()
      .trackReplaceTileAsset(contentType, contentItem.uuid);
  };


export const setTileContentItem = (
  sectionOrId,
  eid,
  contentItemOrUuid,
  { canShowUserCropModal }={}
)=>
  (dispatch, getState)=> {
    const { section, sectionOverrides } = getSectionAndOverrides(getState(), sectionOrId);

    const gridPos = getEditorTileGridPositionByEid(section, sectionOverrides, eid);

    const orphanContentUuidToDelete = gridPos.uuid; // may be null

    const contentUuid = getUuidFrom(contentItemOrUuid);
    const contentItem = getContentItemByUuid(getState(), contentUuid);
    const asset = getAssetForContent(getState(), contentItem);

    const [newSection, newSectionOverrides] = flow(

      ([section, sectionOverrides])=>
        setEditorTileContent(section, sectionOverrides, eid, contentUuid)
      ,
      ([section, sectionOverrides])=>
        removeEditorTileData(section, sectionOverrides, eid)
    
    )([section, sectionOverrides]);

    const { sizex, sizey } = find(newSection.gridPositions, ({ uuid })=> uuid === contentUuid);

    if (orphanContentUuidToDelete) {
      dispatch(endEditingContent([orphanContentUuidToDelete]));
    }

    dispatch(setSectionAndOverrides(section.id, newSection, newSectionOverrides));

    if (orphanContentUuidToDelete) {
      dispatch(deleteContentItems([orphanContentUuidToDelete]));
    }

    if (hasCroppableAssetDisplayImage(asset)) {
      const cropData = getCachedCroppedZfImageFromAsset(asset, { sizex, sizey });

      if (canShowUserCropModal && !cropData) {
        dispatch(showCropperForTile({ contentItem }));
      }
    }
  };


export const editTileActionData = (contentItem, type)=>
  (dispatch)=> {

    if (!includes([LINK_TYPE_INTERNAL, LINK_TYPE_EXTERNAL], type)) {
      throw new Error(`Unexpected action data type ${type}`);
    }
    const tileActionData = 
      type === get(contentItem, 'tile_action_data.type') ?
        { ...contentItem.tile_action_data }

      : type === LINK_TYPE_EXTERNAL ?
        ({ 
          type,
          target: '_blank',
          url: null   
        })
      :
        ({
          type,
          subpageId: null,
          sectionId: null,
          contentUuid: null
        });
    dispatch(setTemporaryTileActionData(tileActionData));
  };


export const setEditingOverlayData = (editingOverlayData)=>
  ({
    type:'SET_EDITING_OVERLAY_DATA',
    editingOverlayData
  });


export const setTemporaryTileActionData = (tileActionData)=>
  ({
    type:'SET_TEMPORARY_TILE_ACTION_DATA',
    tileActionData
  });

export const clearTemporaryTileActionData = ()=>
  ({
    type: 'SET_TEMPORARY_TILE_ACTION_DATA',
    tileActionData: null
  });

export const saveTemporaryTileActionData = ()=>
  (dispatch, getState)=> {
    // TODO: It would be better if we were passed in the contentItem we want to save,
    // but we dont have access to that from the calling content of this function without
    // some significant refactors
    const contentItems = getCurrentlyEditingContentItems(getState());
    if (contentItems.length !== 1) {
      throw new Error('Cannot save temporary tile action data for multiple content items');
    }
    const contentItem = contentItems[0];
    const temporaryTileActionData = getTemporaryTileActionData(getState());
    if (temporaryTileActionData.url) {
      temporaryTileActionData['url'] = prependSchemeIfMissing(temporaryTileActionData.url);
    }
    dispatch(setContentItemSimpleData(contentItem, {
      tile_action_data: temporaryTileActionData
    }));
    if (!contentItem.tile_action_data || contentItem.tile_action_data.type !== temporaryTileActionData.type) {
      getPageHistoryTracker().trackChangeTileAction(
        contentItem.uuid, 
        temporaryTileActionData.type
      );
    }
    dispatch(clearTemporaryTileActionData());
  };
    
export const setStylePreset = (contentItemOrUuid, className)=>
  (dispatch)=> {     
    const contentItemUuid = getUuidFrom(contentItemOrUuid);
    
    dispatch(setContentItemSimpleData(contentItemUuid, {
      style_preset_classname: className
    }));
  };


export const setTileDisplayTypeDefault = (contentItem, extraData={})=>
  (dispatch, getState)=> {
    const asset = getAssetForContent(getState(), contentItem);

    dispatch(setAndUpdateAssetData({
      ...asset,
      cachedCrops: {}
    }));

    dispatch(setContentItemSimpleData(contentItem.uuid, {
      tile_display_type: 'default',
      tile_inner_zf_image: getZfImageForAsset(asset),
      tile_display_image: null,
      thumbnail: null,
      crop_data: {},
      ...extraData
    }));
  };


export const setTileDisplayImageFromVideoFrame = (contentItem, videoFrameSrc)=>
  (dispatch)=> {
    // This newValues construct is a brittle approach since we cannot be certain
    // that the data actually looks like this after it has been sent to the back-end.
    const newValues = {
      tile_display_type: 'video_frame',
      tile_inner_zf_image: getZfImageForImageSrc(videoFrameSrc)
    };

    // So we really don't want to update anything before the cropping is complete, 
    // but unfortunately this is how we have been doing things in the past and it 
    // is a bit hard to change now
    dispatch(setContentItemSimpleData(contentItem.uuid, newValues));

    defer(()=> {
      // Management modals can only exist one at a time, so we must give the media 
      // library modal a chance to close itself before we open the cropper modal
      dispatch(showCropperForTile({ contentItem: { ...contentItem, ...newValues }, shouldClearCachedCrops: true }));
    });
  };


export const setTileDisplayImageFromPresentationSlide = (contentItem, presentationSlideSrc)=>
  (dispatch)=> {
    // This newValues construct is a brittle approach since we cannot be certain
    // that the data actually looks like this after it has been sent to the back-end.
    const newValues = {
      tile_display_type: 'ppt_slide',
      tile_inner_zf_image: getZfImageForImageSrc(presentationSlideSrc)
    };

    // So we really don't want to update anything before the cropping is complete, 
    // but unfortunately this is how we have been doing things in the past and it 
    // is a bit hard to change now
    dispatch(setContentItemSimpleData(contentItem.uuid, newValues));

    defer(()=> {
      // Management modals can only exist one at a time, so we must give the media 
      // library modal a chance to close itself before we open the cropper modal
      dispatch(showCropperForTile({ contentItem: { ...contentItem, ...newValues }, shouldClearCachedCrops: true }));
    });
  };


export const setTileDisplayImageFromMediaLibrary = (contentItem, asset)=>
  (dispatch)=> {
    // This newValues construct is a brittle approach since we cannot be certain
    // that the data actually looks like this after it has been sent to the back-end.
    const imageSrc = asset.displayImage || asset.originalImage; // need to confirm whether this change is ok
    const newValues = {
      tile_display_type: 'library',
      tile_inner_zf_image: getZfImageForImageSrc(imageSrc)
    };

    // So we really don't want to update anything before the cropping is complete, 
    // but unfortunately this is how we have been doing things in the past and it 
    // is a bit hard to change now
    dispatch(setContentItemSimpleData(contentItem.uuid, newValues));

    defer(()=> {
      // Management modals can only exist one at a time, so we must give the media 
      // library modal a chance to close itself before we open the cropper modal
      dispatch(showCropperForTile({ contentItem: { ...contentItem, ...newValues }, shouldClearCachedCrops: true }));
    });
  };

export const setTileAssetFromMediaLibrary = (contentItem, asset)=>
  (dispatch, getState)=> {
    const contentType = getContentItemType(contentItem);

    const section = getSectionForContent(getState(), contentItem);

    const { sizex, sizey } = find(section.gridPositions, ['uuid', contentItem.uuid]);

    // There is an edge case where a photo tile has a invalid tile_display_type 
    // inherited from another tile after a replace. In that case to allow for 
    // users to still change the image we manually set the display type to default 
    // here.
    if(contentItem.tile_display_type == 'library' && asset.assetType == 'photo'){
      contentItem.tile_display_type = 'default';
    }

    // we want to keep thumbnails that have been selected from the media
    // library but otherwise we want to reset them to the default setting
    if (contentItem.tile_display_type !== 'library') {
      dispatch(setContentItemSimpleData(contentItem.uuid, {
        tile_display_type: 'default',
        tile_display_image: '', // probably should remove this
        crop_data: {},
        tile_inner_zf_image: getZfImageForAsset(asset)
      }));
    }

    dispatch(setContentItemAsset(contentItem, asset));

    getPageHistoryTracker()
      .trackReplaceTileAsset(contentType, contentItem.uuid);

    // if the tile_display_type is from the media library we don't want to
    // propmt cropping since they have previously set this image explicitly. they
    // can choose to crop it as a separate action in the UI.
    if (contentItem.tile_display_type !== 'library' && hasCroppableAssetDisplayImage(asset)) {

      const cachedZfImage = getCachedCroppedZfImageFromAsset(asset, { sizex, sizey });
      if (cachedZfImage) {
        dispatch(setContentItemSimpleData(contentItem.uuid, {
          tile_inner_zf_image: cachedZfImage
        }));

      } else {
        defer(()=> {
          // Management modals can only exist one at a time, so we must give the media 
          // library modal a chance to close itself before we open the cropper modal
          dispatch(showCropperForTile({ contentItem: { ...contentItem, tile_inner_zf_image: getZfImageForAsset(asset) } }));
        });
      }
    }

  };


export const setTileIsLoading = (contentItemOrUuid, value)=>
  (dispatch, getState)=> {
    const contentUuid = getUuidFrom(contentItemOrUuid);
    const section = getSectionForContent(getState(), contentUuid);
    const sectionOverrides = getEditorOnlySectionOverrides(getState(), section);

    const eid = getEditorTileEidByContentUuid(section, sectionOverrides, contentUuid);

    var newSection, newSectionOverrides;
    if (value) {
      [newSection, newSectionOverrides] = setEditorTileData(section, sectionOverrides, eid, { isLoading:value });
    } else {
      [newSection, newSectionOverrides] = removeEditorTileData(section, sectionOverrides, eid);
    }

    dispatch(setSectionAndOverrides(section.id, newSection, newSectionOverrides));
  };
 

export const updateGridPositionsContentSectionWithNewContent = (
  section,
  contentItem,
  positionData={},
  {
    shouldEditOnCreate,
    canShowUserCropModal,
    shouldScrollToOnCreate
  }={}
) =>
  (dispatch, getState) => {
    const { eid } = positionData;
    dispatch(setTileContentItem(section, eid, contentItem, { canShowUserCropModal }));

    const subpage = getSubpageForSection(getState(), section);

    if (!subpage) {  // This is a tab section
      return;
    }

    const menuItemForSubpage = getPrimaryMenuItemForSubpage(getState(), subpage);
    const contentType = getContentItemType(contentItem);
    const asset = getAssetForContent(getState(), contentItem);

    const isEncoding = get(asset, 'isEncoding');

    getPageHistoryTracker()
      .trackAddContent(contentItem.uuid, contentType, menuItemForSubpage.title);

    if (shouldEditOnCreate && !isEncoding) {
      dispatch(beginEditingContent([contentItem]));
    }
    if (shouldScrollToOnCreate) {
      dispatch(goToContent(contentItem));
    }
  };

export const confirmDeleteTile = (contentItemOrUuid)=>
  (dispatch, getState)=> {
    const contentItemUuid = getUuidFrom(contentItemOrUuid);
    const contentItem = getContentItemByUuid(getState(), contentItemUuid);

    dispatch(showModal(ConfirmDeleteTileModal, { contentItem }));
  };


export const showConfirmPresentationForTileModal = (contentItem, section)=>
  (dispatch, getState)=> {
    const sectionOverrides = getEditorOnlySectionOverrides(getState(), section.id);
    const eid = getEditorTileEidByContentUuid(section, sectionOverrides, contentItem.uuid);

    dispatch(showModal(ConfirmCreatePresentationForTileModal, { eid, section }));
  };


export const showConfirmHtmlPackageForTileModal = (contentItem, section)=>
  (dispatch, getState)=> {
    const sectionOverrides = getEditorOnlySectionOverrides(getState(), section.id);
    const eid = getEditorTileEidByContentUuid(section, sectionOverrides, contentItem.uuid);

    dispatch(showModal(ConfirmCreateHtmlPackageForTileModal, { eid, section }));
  };


export const updateGridSectionAfterEncoding = (section, contentUuid) =>
  (dispatch, getState) => {
    const sectionOverrides = getEditorOnlySectionOverrides(getState(), section.id);
    const eid = getEditorTileEidByContentUuid(section, sectionOverrides, contentUuid);

    const [newSection, newSectionOverrides] = removeEditorTileData(section, sectionOverrides, eid);

    dispatch(setSectionAndOverrides(section.id, newSection, newSectionOverrides));
  };

export const createTileCreatorTileForGridSection = (
  section,
  gridPositionData,
  tileCreatorData
) =>
  (dispatch, getState) => {
    var { sectionOverrides } = getSectionAndOverrides(getState(), section);
    const newEid = generateEid();    

    [section, sectionOverrides] = createEditorTileAtPosition(
      section,
      {
        ...sectionOverrides,
        editorOnlyTileDataByEid: {
          [newEid]: tileCreatorData,
          ...sectionOverrides.editorOnlyTileDataByEid
        }
      },
      newEid,
      gridPositionData,
      tileCreatorData
    );

    dispatch(setSectionAndOverrides(section.id, section, sectionOverrides));
  };

export const createContentItemFromContentForGridSection = (
  section,
  contentItem,
  gridPositionData,
  {
    shouldCreateAtEnd=true,
    shouldCreateTileCreatorAtPosition=false,
    shouldScrollToOnCreate=false,
    shouldEditOnCreate=false,
    canShowUserCropModal=false
  } = {}
)=>
  (dispatch, getState)=> {
    var { sectionOverrides } = getSectionAndOverrides(getState(), section);
    const newEid = generateEid();
    const contentItemData = getSerializableContentDataForCopy(contentItem);

    if (contentItemData.asset_type && contentItemData.asset_id) {
      dispatch(fetchAndUpdateAssetData(contentItemData.asset_type, contentItemData.asset_id));
    }

    if (shouldCreateAtEnd) {
      [section, sectionOverrides] = createEditorTileAtEnd(
        section,
        sectionOverrides,
        newEid,
        gridPositionData
      );
    } else if (shouldCreateTileCreatorAtPosition) {
      [section, sectionOverrides] = createEditorTileAtPosition(
        section,
        sectionOverrides,
        newEid,
        gridPositionData
      );
    }

    dispatch(setSectionAndOverrides(section.id, section, sectionOverrides));
    dispatch(prepTileForReplace(section, newEid, { shouldCreateAtEnd }));

    const extraData = {
      shouldEditOnCreate: shouldEditOnCreate,
      shouldScrollToOnCreate: shouldScrollToOnCreate,
      canShowUserCropModal: canShowUserCropModal
    };

    dispatch(createContentItem(section, contentItemData, { eid: newEid }, extraData));
  };

export const setShouldShowGridLines = (shouldShowGridLines) =>
    (dispatch)=>
      dispatch({ type: SET_SHOULD_SHOW_GRID_LINES, shouldShowGridLines });

export const setIsGridTaxonomyEnabled = (section, isEnabled)=>
  (dispatch)=> {
    dispatch({
      isEnabled,
      sectionId: getIdFrom(section),
      type: SET_IS_GRID_TAXONOMY_ENABLED
    });

    dispatch(ensureThrottledPageConfigSaving());
  };

export const setGridTaxonomyFilterType = (section, filterType)=>
  (dispatch)=> {
    dispatch({
      filterType,
      sectionId: getIdFrom(section),
      type: SET_GRID_TAXONOMY_FILTER_TYPE
    });

    dispatch(ensureThrottledPageConfigSaving());
  };

export const setGridTaxonomyFilterLogicalOperator = (section, logicalOperator)=>
  (dispatch)=> {
    dispatch({
      logicalOperator,
      sectionId: getIdFrom(section),
      type: SET_GRID_TAXONOMY_FILTER_LOGICAL_OPERATOR
    });

    dispatch(ensureThrottledPageConfigSaving());
  };

export const setGridTaxonomyFilterToggleText = (section, toggleText)=>
  (dispatch)=> {
    dispatch({
      toggleText,
      sectionId: getIdFrom(section),
      type: SET_GRID_TAXONOMY_FILTER_TOGGLE_TEXT
    });

    dispatch(ensureThrottledPageConfigSaving());
  };

export const addGridTaxonomyCategoryForGridSection = (sectionId)=>
  (dispatch)=> {
    const newCategory = {
      id: generateGridTaxonomyCategoryId(),
      label: '',
      isHidden: false,
      tags: []
    };

    dispatch({
      sectionId,
      newCategory,
      type: ADD_GRID_TAXONOMY_CATEGORY
    });
  };

export const removeGridTaxonomyCategoryForGridSection = (sectionId, categoryId)=>
  removeGridTaxonomyCategoriesForGridSection(sectionId, [ categoryId ]);

export const removeGridTaxonomyCategoriesForGridSection = (sectionId, categoryIds)=>
  (dispatch)=> {
    forEach(categoryIds, (categoryId) => 
      dispatch({
        sectionId,
        categoryId,
        type: REMOVE_GRID_TAXONOMY_CATEGORY
      })
    );

    dispatch(ensureThrottledPageConfigSaving());
  };

export const setGridTaxonomyCategoryData = (sectionId, categoryId, data)=>
  (dispatch)=> {
    dispatch({
      sectionId,
      categoryId,
      data,
      type: SET_GRID_TAXONOMY_CATEGORY_DATA
    });

    dispatch(ensureThrottledPageConfigSaving());
  };

export const setGridTaxonomyCategoriesOrder = (sectionId, oldCategoryIdx, newCategoryIdx)=>
  (dispatch)=> {
    dispatch({
      sectionId,
      oldCategoryIdx,
      newCategoryIdx,
      type: SET_GRID_TAXONOMY_CATEGORIES_ORDER
    });

    dispatch(ensureThrottledPageConfigSaving());
  };

export const setGridTaxonomyCategoryTags = (sectionId, categoryId, tagLabels)=>
  (dispatch, getState)=> {
    const category = getSectionGridTaxonomyCategory(getState(), sectionId, categoryId);

    if (!category) {
      throw new Error(`Could not find category with ID ${categoryId}`);
    }

    const existingTagLabels = map(category.tags, 'label');

    var newTags;

    if (tagLabels.length > existingTagLabels.length) {
      const newTagLabels = difference(tagLabels, existingTagLabels);
      const newTagsWithIds = map(newTagLabels, (tagLabel)=> {
        return {
          label: tagLabel,
          id: generateGridTaxonomyTagId()
        };
      });

      newTags = [...category.tags, ...newTagsWithIds];

    } else {
      newTags = filter(category.tags, (tag)=> {
        return !includes(difference(existingTagLabels, tagLabels), tag.label);
      });

    }

    dispatch(setGridTaxonomyCategoryData(
      sectionId,
      categoryId,
      { tags: newTags }
    ));

    dispatch(ensureThrottledPageConfigSaving());
  };

export const createGridSectionFromTilesData = (
  existingSectionData,
  existingTilesData,
  subpage,
  atIndex,
  tab = null
) =>
  (dispatch, getState) => {
    const {
      type
    } = existingSectionData;

    const newSection = generateNewSectionData(
      type,
      existingSectionData
    );

    const initialSectionOverrides =
      generateInitialSectionOverridesForSection(newSection);

    dispatch({
      type: ADD_SECTION,
      section: newSection,
      subpage: subpage,
      index: atIndex,
      tab: tab,
      sectionOverrides: initialSectionOverrides,
      shouldEditSection: true
    });

    getPageHistoryTracker().trackAddSection(
      getSubpageDisplayName(getState(), subpage),
      getDisplayName(newSection)
    );

    each(existingTilesData, (tileData) => {
      const {
        sizex,
        sizey,
        row,
        col,
        isTileCreator
      } = tileData;

      const positionData = {
        sizex, sizey, row, col
      };

      /**
       * We inject tile creators into the section
       * automagically when building our initial
       * section overrides, so this is a little
       * misleading.
       * 
       * It's misleading because we shouldn't
       * necessarily have to check for tile
       * creators that should already exist, but
       * we are going to maintain this for now to
       * assert that this content already exists
       * and is not temp-content in the way that
       * a tile creator is.
       **/

      if (!isTileCreator) {
        const postCreateData = {
          shouldCreateAtEnd: false,
          shouldCreateTileCreatorAtPosition: true,
          shouldEditOnCreate: false,
          shouldScrollToOnCreate: false,
          canShowUserCropModal: false
        };

        dispatch(createContentItemFromContentForGridSection(
          newSection,
          tileData,
          positionData,
          postCreateData
        ));
      }
    });

    dispatch(ensureThrottledPageConfigSaving());

    defer(() => {
      dispatch(scrollToSection(newSection.id));
    });

  };
